import React from 'react';
import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';

/**
 * Komponente zum Anzeigen des aktuellen Breakpoints für Debugging-Zwecke
 */
const BreakpointIndicator = () => {
  const theme = useTheme();
  
  // Prüfe die verschiedenen Breakpoints
  const isXs = useMediaQuery(theme.breakpoints.only('xs'));
  const isSm = useMediaQuery(theme.breakpoints.only('sm'));
  const isMd = useMediaQuery(theme.breakpoints.only('md'));
  const isLg = useMediaQuery(theme.breakpoints.only('lg'));
  const isXl = useMediaQuery(theme.breakpoints.only('xl'));

  // Bestimme den aktuellen Breakpoint
  let currentBreakpoint = 'unknown';
  if (isXs) currentBreakpoint = 'xs (< 600px)';
  else if (isSm) currentBreakpoint = 'sm (600px - 900px)';
  else if (isMd) currentBreakpoint = 'md (900px - 1200px)';
  else if (isLg) currentBreakpoint = 'lg (1200px - 1536px)';
  else if (isXl) currentBreakpoint = 'xl (> 1536px)';

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 0,
        right: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        color: 'white',
        padding: '4px 8px',
        borderRadius: '4px 0 0 0',
        zIndex: 9999,
        fontSize: '12px',
      }}
    >
      <Typography variant="caption">Breakpoint: {currentBreakpoint}</Typography>
    </Box>
  );
};

export default BreakpointIndicator;